export const IMAGES = {
	LightBd: require('./img/bg.jpg').default,
};
